import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { NewProjectInitialValue, NewProjectValidation } from "../../../../data/applications/Project";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setCreatedData } from "../../../../reduxToolkit/reducers/projectSlice";
import { ProjectValue } from "../../../../types/Applications";
import { routes } from "../../../../routers/routes";
import TitleAndDetails from "./TitleAndDetails";
import DatesAndDetails from "./DatesAndDetails";
import ProjectFileUpload from "./UploadProjectFile";

// ProjectForm component for creating and submitting a new project.
const ProjectForm = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { createdFormData } = useAppSelector((state) => state.project);
  const randomValue = Math.floor(Math.random() * (100 - 10 + 1)) + 10;

  // Function to handle project submission
  const projectSubmit = (values: ProjectValue) => {
    const submittedData = {
      id: randomValue.toString(),
      title: values.title,
      badge: values.progress === 100 ? "Done" : "Doing",
      image: "3.jpg",
      sites: "ThemeForest, australia",
      description: "Zono Admin is a full featured, multipurpose, premium bootstrap admin template.",
      issue: randomValue.toString(),
      resolved: randomValue.toString(),
      comment: randomValue.toString(),
      like: randomValue.toString(),
      customers_img1: "3.jpg",
      customers_img2: "5.jpg",
      customers_img3: "1.jpg",
      progress: values.progress,
      projectLevel: values.progress,
    };
    dispatch(setCreatedData([...createdFormData, submittedData]));
    navigate(routes.Project.List);
  };

  return ( 
    <Formik initialValues={NewProjectInitialValue} validationSchema={NewProjectValidation} onSubmit={projectSubmit}>
      {() => (
        <Form className="theme-form">
          <TitleAndDetails />
          <DatesAndDetails />
          <ProjectFileUpload />
        </Form>
      )}
    </Formik>
  );
};
export default ProjectForm;